import { I18n } from "@/shared/util/translations.ts";

export function name_for_legacy(country_code: string | null | undefined) {
  return country_code
    ? I18n.t(to_iso_3166_1(country_code).toUpperCase(), {
        scope: "countries",
      })
    : "";
}

// Mirrors Legacy::CountryMapping on the backend. Legacy "sr" is Serbia, so
// Suriname (ISO "sr") got "xs" from the ISO user-assigned range.
const legacyToIso = new Map([
  ["uk", "gb"],
  ["sr", "rs"],
  ["xs", "sr"],
]);

function to_iso_3166_1(country_code: string) {
  return legacyToIso.get(country_code) ?? country_code;
}
